'use client';
import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.palette.white};
  padding: 120px 0px 80px 0px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 80px 36px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-direction: row;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    gap: 30px;
    flex-direction: column;
    display: flex;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    gap: 30px;
    flex-direction: column;
    display: flex;
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 1px solid ${({ theme }) => theme.palette.grey300};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    border-left: none;
    border-top: 1px solid ${({ theme }) => theme.palette.grey300};
    margin-top: 40px;
    padding-top: 24px;
  }
`;

export const FooterSeparator = styled.div.attrs({
  'data-testid': 'footer-separator',
})`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.grey300};
  margin: 40px 0px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
  }
`;
